import { Select } from "antd";
import * as React from "react";
import { defaultGroupBy, defaultView } from "../../../constants";
import _ from "lodash";
const Option = Select.Option;
import "./style.scss";
interface CompareBySelectProps {
  metric: string;
  group_by: string;
  view: string;
  initial_selection_key?: string;
  onMenuSelect?: (metric: string) => void;
}

export default class CompareBySelect extends React.Component<
  CompareBySelectProps,
  {}
> {
  shouldComponentUpdate(nextProps: any, nextState: any) {
    return !_.isEqual(this.props, nextProps);
  }
  handleSelection(key: string) {
    let compare_by = compare_by_key_map[key];

    if (this.props.onMenuSelect) {
      this.props.onMenuSelect(key == "compare_by_null" ? null : compare_by);
    }
  }

  renderOptions() {
    let { metric, group_by, view } = this.props;
    let optionItems: any = [];
    (Object as any)
      .entries(getCompareByItems(metric, view, group_by))
      .map((option: any) => {
        optionItems.push(<Option key={option[0]}>{option[1]}</Option>);
      });
    return optionItems;
  }
  validateInitialSelection() {
    let { metric, view, group_by } = this.props;
    let menuItems = getCompareByItems(metric, view, group_by);
    if (menuItems[this.props.initial_selection_key]) {
      return this.props.initial_selection_key;
    } else {
      return "compare_by_null";
    }
  }

  render() {
    return (
      <div className="compare-by-select">
        <Select
          size="default"
          placeholder="Select Compare By"
          style={{ width: "100%" }}
          value={this.validateInitialSelection()}
          onChange={this.handleSelection.bind(this)}
        >
          {this.renderOptions()}
        </Select>
      </div>
    );
  }
}

export const getCompareByItems = (
  metric: string,
  view: string,
  group_by: string
) => {
  view = view ? view : defaultView(metric);
  group_by = group_by ? group_by : defaultGroupBy(metric, view);
  switch (metric) {
    case "clicks":
      if (view == "bar") {
        if (
          group_by == "item" ||
          group_by == "section" ||
          group_by == "region"
        ) {
          return compare_by_items;
        }
        if (group_by == "device") {
          return compare_by_items_publication_channel;
        }
        if (group_by == "channel") {
          return compare_by_items_publication_device;
        }
        if (group_by == "publication") {
          return compare_by_items_device_channel;
        }
      }
      if (view == "line") {
        return compare_by_items;
      }
    case "opens":
      if (view == "bar") {
        if (group_by == "region") {
          return compare_by_items;
        }
      }
    case "unique_engaged_visits":
      if (view == "bar") {
        if (group_by == "region") {
          return compare_by_items;
        }
      }
    case "impressions":
    case "average_time_on_flyer":
      if (view == "bar") {
        if (group_by == "device") {
          return compare_by_items_publication_channel;
        }
        if (group_by == "channel") {
          return compare_by_items_publication_device;
        }
        if (group_by == "publication") {
          return compare_by_items_device_channel;
        }
      }
      if (view == "line") {
        return compare_by_items;
      }
    default:
      return {
        compare_by_null: (
          <div className="compare-by-null-option">Select Compare By</div>
        )
      };
  }
};

const optionElement = (name: string) => {
  const icon = <img src={`/icon_${name}.svg`} />;
  return (
    <div
      className="compare-by-option"
      data-automation-id={`compare-by-${name.toLowerCase()}`}
    >
      {icon}
      <div className="compare-by-text">{_.startCase(name)}</div>
    </div>
  );
};

const compare_by_items: any = {
  compare_by_null: (
    <div className="compare-by-null-option">Select Compare By</div>
  ),
  compare_by_publication: optionElement("publication"),
  compare_by_device: optionElement("device"),
  compare_by_channel: optionElement("channel")
};

const compare_by_items_publication_channel: any = {
  compare_by_null: (
    <div className="compare-by-null-option">Select Compare By</div>
  ),
  compare_by_publication: optionElement("publication"),
  compare_by_channel: optionElement("channel")
};

const compare_by_items_device_channel: any = {
  compare_by_null: (
    <div className="compare-by-null-option">Select Compare By</div>
  ),
  compare_by_device: optionElement("device"),
  compare_by_channel: optionElement("channel")
};

const compare_by_items_publication_device: any = {
  compare_by_null: (
    <div className="compare-by-null-option">Select Compare By</div>
  ),
  compare_by_publication: optionElement("publication"),
  compare_by_device: optionElement("device")
};

export const compare_by_key_map: any = {
  compare_by_publication: "publication",
  compare_by_device: "device",
  compare_by_channel: "channel"
};

export const supported_compare_bys: any = {
  publication: true,
  device: true,
  channel: true
};



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Dropdown/CompareBySelect/index.tsx